import { useState } from 'react'
import Tooltip from '../../../components/tooltip/Tooltip'
import NoneAnchor from '../../../components/NoneAnchor'
import Button from '../../../components/form/Button'
import Icon from '../../../components/Icon'
import PropTypes from 'prop-types'
import { useConfirm } from '../../dialog/Confirm'
import { fetchChannels, unmapTalkChannel } from './channelListSlice'
import { useDispatch } from 'react-redux'
import { failWithErrorResponse } from '../../toast/Toast'

const { REACT_APP_PF_HOST } = process.env

export const UnmapTalkChannelTooltip = () => (
  <Tooltip
    position="bottom alignLeft"
    content={
      <>
        <a
          href={REACT_APP_PF_HOST}
          target="_blank"
          rel="noopener noreferrer"
          className="link_txt">
          카카오톡채널 관리자센터
        </a>
        를 통해
        <br />
        해당 프로필 상태를 확인 바랍니다.
      </>
    }>
    <NoneAnchor className="fc_warn link_g">[조회불가]</NoneAnchor>
  </Tooltip>
)
const WebsiteTalkChannelItem = ({
  bizChannelId,
  talkChannelId,
  talkChannelName,
  talkChannelStatus,
}) => {
  const dispatch = useDispatch()
  const [UnmapTalkChannel, showUnmapTalkChannel] = useConfirm()
  const [hover, setHover] = useState(false)

  const handleUnmapTalkChannel = async ({ isConfirmed }) => {
    if (!isConfirmed) return

    const { error, payload } = await dispatch(
      unmapTalkChannel({
        bizChannelId,
        talkChannelId,
      })
    )

    if (error) {
      failWithErrorResponse(payload)
    } else {
      dispatch(fetchChannels())
    }
  }

  return (
    <>
      <div
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}>
        <span className="limit_line">
          {talkChannelStatus !== 'ACTIVATED' && <UnmapTalkChannelTooltip />}
          {talkChannelName}
        </span>
        {hover && (
          <Button className="btn_del" onClick={showUnmapTalkChannel}>
            <Icon name="del">삭제</Icon>
          </Button>
        )}
      </div>

      <UnmapTalkChannel onClose={handleUnmapTalkChannel}>
        카카오톡 채널을 삭제하시겠습니까?
      </UnmapTalkChannel>
    </>
  )
}

WebsiteTalkChannelItem.propTypes = {
  bizChannelId: PropTypes.string.isRequired,
  talkChannelId: PropTypes.string.isRequired,
  talkChannelName: PropTypes.string.isRequired,
  talkChannelStatus: PropTypes.string.isRequired,
}

export default WebsiteTalkChannelItem
